import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { ProgressButton } from '@beeline/design-system-react/extracted-styles';

import { Panel } from 'src/components/Panel/Panel';
import { getPermissionsState } from 'src/store/permissions/selectors';
import { saveEmployeePermissions } from 'src/store/permissions/services';
import { useAppDispatch } from 'src/store/useAppDispatch';

import { AdministratorUserPermissionsFields } from './AdministratorUserPermissionsFields';

const Actions: FC = () => {
  const dispatch = useAppDispatch();
  const { employee, loading } = useSelector(getPermissionsState);

  const save = useCallback(async () => {
    await dispatch(saveEmployeePermissions());
  }, [dispatch]);

  return (
    <ProgressButton
      variant='contained'
      onClick={save}
      disabled={!employee || loading}
      data-testid='updatePermissionsButton'
      statusDelayTime={0}
      fullWidth
    >
      Сохранить
    </ProgressButton>
  );
};

export const AdministratorUserPermissionsSidesheetPanel: FC = () => {
  return (
    <Panel actions={<Actions />}>
      <AdministratorUserPermissionsFields />
    </Panel>
  );
};
